import Repository from './Repository'

const actionTask = 'call-center/tasks'
const actionCall = 'call-center/calls'
const actionContact = 'call-center/contacts'

export default {
  /** Tasks **/
  getTasksList(settings = {}) {
    let params = ''

    for (let key in settings) {
      if (settings[key] || settings[key] === 0) {
        params += params ? '&' : '?'
        params += `${key}=${settings[key]}`
      }
    }

    return Repository.get(actionTask + params)
  },
  getTask(id) {
    return Repository.get(`${actionTask}/${id}`)
  },
  postTask(data) {
    return Repository.post(actionTask, data)
  },
  updateTask(id, data) {
    return Repository.put(`${actionTask}/${id}`, data)
  },
  addContactsToTask(id, data) {
    return Repository.post(`${actionTask}/${id}/contacts`, data)
  },
  deleteContactFromTask(id, contact_ids) {
    return Repository.delete(
      `${actionTask}/${id}/contacts?contact_ids=${contact_ids}`,
    )
  },
  deleteTask(id) {
    return Repository.delete(`${actionTask}/${id}`)
  },
  /** Calling **/
  postCall(data) {
    return Repository.post(actionCall, data)
  },
  /** Contacts **/
  getContactsList(settings = {}) {
    let params = ''

    for (let key in settings) {
      if (settings[key]) {
        params += params ? '&' : '?'
        params += `${key}=${settings[key]}`
      }
    }

    return Repository.get(actionContact + params)
  },
  getContact(id) {
    return Repository.get(`${actionContact}/${id}`)
  },
  postContact(data) {
    return Repository.post(actionContact, data)
  },
}
